<template>
  <div class="add-payment" v-if="addnewProp.isRed">
    <div class="el-form" v-if="paymentSheetList.length">
      <h3 class="title">关联回款单</h3>
      <div class="el-form-item">
        <label class="el-form-item__label">关联回款</label>
        <ul class="el-form-item__content">
          <li class="item" v-for="(item, index) in paymentSheetList" :class="{checked: checkedPaymentSheets[index]}" :key="index">
            <h4 class="tit">{{item.sheetNo}}</h4>
            <p class="con"><span class="text">回款日期：{{item.paymentTime}}</span> {{item.amount}}元</p>
            <span class="checkbox" :class="{checked: checkedPaymentSheets[index]}" @click="paymentSheetHandle(index, item)"></span>
          </li>
        </ul>
      </div>
      <div class="el-form-item">
        <label class="el-form-item__label">红冲回款金额(元)</label>
        <div class="el-form-item__content">
          <el-input v-model.number="totalMoney" disabled></el-input>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import * as api from 'src/api'
let lazy
export default {
  props: {
    addnewProp: {
      required: true
    },
    id: {
      required: true
    },
    checkedPaymentSheets: {
      required: true
    },
    form: {
      required: true
    }
  },
  computed: {
    formatPaymentSheets () {
      return this.checkedPaymentSheets.filter(item => item)
    }
  },
  data () {
    return {
      paymentSheetList: '',   //  关联回款单拿到的数据
      decimalPrecision: 2, // 红冲回款金额精度
      totalMoney: 0   //  红冲回款的总金额
    }
  },
  watch: {
    form: {
      handler (form) {
        clearTimeout(lazy)
        lazy = setTimeout(() => {
          this.cotractId = form.contractId
        }, 50)
      },
      deep: true
    },
    checkedPaymentSheets: {
      handler (arr) {
        arr = this.checkedPaymentSheets.filter(item => item)
      },
      deep: true
    },

    totalMoney () {
      this.$emit('updateTotalMoney', this.totalMoney)
    }
  },
  mounted () {
    let url = `/refund/getPaymentSheet.html`
    let params = {refId: this.id, type: 'paymentApi'}
    api.post(url, params, (data) => {
      this.paymentSheetList = data.paymentSheetList
      this.decimalPrecision = data.decimalPrecision
    })
  },
  methods: {
    // 选中回款单
    paymentSheetHandle (index, item) {
      if (this.checkedPaymentSheets[index]) {
        this.$set(this.checkedPaymentSheets, index, undefined)
      } else {
        this.$set(this.checkedPaymentSheets, index, item)
      }
      this.countTotalMoney()
    },

    //  计算总的价钱
    countTotalMoney () {
      let num = 0
      if (this.formatPaymentSheets.length) {
        this.formatPaymentSheets.forEach(item => {
          num += Number(item.amount)
        })
      } else {
        num = 0
      }
      num = Number(num.toFixed(this.decimalPrecision)) // 限制金额小数
      this.totalMoney = num
    }
  }
  // filters: {
  //   formatMoney (num) {
  //     return num.toLocaleString()
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import '../../../assets/less/variable.less';
.add-payment {
    padding-right: 50px;
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
      margin: 30px 0;
      .name {
        display: inline-block;
        vertical-align: top;
        width: 98px;
      }
    }
    .el-form-item__content {
      margin-left: 124px;
      .item {
        border:1px solid #dedede;
        border-radius:2px;
        padding: 0 5px;
        position: relative;
        margin-bottom: 10px;
        transition: all 0.3s;
        &.checked {
          border-color: #ff943e
        }
        &:last-child {
          margin-bottom: 0;
        }
        .tit, .con {
          font-size: 13px;
          line-height: 1;
          padding: 12px 4px;
        }
        .tit {
          border-bottom: 1px dashed #d8d8d8;
        }
        .con {
          color: @light-gray;
          text-align: right;
          overflow: hidden;
          .text {
            float: left;
          }
        }
        .con+.con {
          padding-top: 0;
        }
        .checkbox {
          display: inline-block;
          position: absolute;
          border: 1px solid #bfcbd9;
          border-radius: 4px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          background-color: #fff;
          cursor: pointer;
          z-index: 1;
          transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
          right: 10px;
          top: 8px;
          &:hover {
            border-color: #ff943e;
          }
          &:after {
            box-sizing: content-box;
            content: "";
            border: 2px solid #fff;
            border-left: 0;
            border-top: 0;
            height: 8px;
            left: 5px;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 4px;
            transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
            transform-origin: center;
          }
          &.checked {
            background-color: #ff943e;
            border-color: @bg-orange;
            &:after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// add-payment.vue?0932c66a